import React from 'react';
import { Link, useWindowSize } from 'vindi-ds-components';
import Header from '@templates/header';

function HeaderSubscriptions() {
  const { isMobile } = useWindowSize();

  return (
    <>
      {isMobile ? (
        <Header.Mobile
          links='/admin/reports'
          title='Assinaturas'
        />
      ) : (
        <Header.WithoutAction
          links={[
            <Link href='/admin/dashboard'>Início</Link>,
            <Link href='/admin/reports'>Relatórios</Link>,
          ]}
          title='Assinaturas'
        />
      )}
    </>
  );
}

export default HeaderSubscriptions;
